export const removeQueryStringInS3Link = (url: string) => {
  const split = url.split('?');
  return split[0];
};
